import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=32bbc801&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=32bbc801&prod&lang=css"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=32bbc801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bbc801",
  null
  
)

export default component.exports